import instance from '../instance';

export const getAllActivities = async (query, sort) => {
  try {
    const res = await instance.get('/activities', {
      params: { query, sort },
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const getPaginated = async (page, perPage, search, sort) => {
  try {
    const res = await instance.get('/activities/paginated', {
      params: { page, perPage, search, sort },
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const create = async (data) => {
  try {
    const res = await instance.post('/activities', data);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const edit = async (data) => {
  try {
    const res = await instance.put('/activities', data);
    return res.data;
  } catch (error) {
    throw error;
  }
};
